export const UNAUTHORIZED = 'Unauthorized';
export const TOTP_CONFIG_REQUIRED = 'TOTP_AUTH_CONFIGURATION_REQUIRED_FOR_USER';
export const MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED';
